export enum ANDROID_PERMISSION {
  BLUETOOTH_CONNECT = 'android.permission.BLUETOOTH_CONNECT',
  BLUETOOTH_SCAN = 'android.permission.BLUETOOTH_SCAN',
}
